import { postOrdersOrderIdPaymentsExpressPayout } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { getOrderDetailQueryKey } from "Order/Api/Query/useOrderDetailQuery";
import { getOrderChargeListQueryKey } from "Order/Modules/Payment/Api/Query/useOrderChargeListQuery";
import { getOrderChargesSumQueryKey } from "Order/Modules/Payment/Api/Query/useOrderChargesSumQuery";
import { getOrderFeeQueryKey } from "Order/Modules/Payment/Api/Query/useOrderFeeQuery";
import { getOrderPaymentDetailQueryKey } from "Order/Modules/Payment/Api/Query/useOrderPaymentDetailQuery";
import { getOrderPaymentListQueryKey } from "Order/Modules/Payment/Api/Query/useOrderPaymentListQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export const useExpressPayoutMutation = (orderId: number) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(() =>
			postOrdersOrderIdPaymentsExpressPayout(orderId),
		),
		onError: (error) => {
			console.error("Failed to create express payment", error);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: getOrderChargeListQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderChargesSumQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderPaymentDetailQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderFeeQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderPaymentListQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderDetailQueryKey(orderId),
			});
			toast.success("Express payment was sent");
		},
	});
};
